import { Component, OnInit } from '@angular/core';
import { AuthRequestVM, SignInRequestVM, AuthResponseVM, AccountStatus } from '../../../models';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'auth-login',
  templateUrl: './login.component.html'
})
export class LoginComponent extends BaseComponent implements OnInit {

  model: SignInRequestVM;
  myForm: FormGroup;
  accountLocked: boolean = false;

  constructor(private fb: FormBuilder, private authService: AuthService, private router: Router, route: ActivatedRoute) {
    super(route);
    this.model = new SignInRequestVM();
  }

  ngOnInit(): void {
    this.myForm = this.fb.group({
      username: new FormControl('', [Validators.email, Validators.required]),
      password: new FormControl('', Validators.required)
    });
  }

  onSubmit(value: string) {
    this.hideMessageBox();
    if (this.myForm.valid) {
      this.emitDisplayLoadingDialog(true);
      this.authService.login(this.model)
        .subscribe(
          (returnValue) => this.signinResult(returnValue),
          error => { },
          () => { this.emitDisplayLoadingDialog(false); }
        );
    }
  }

  signinResult(response: AuthResponseVM) {
    if (response.accountStatus == AccountStatus.active && response.jwt != null) {
      localStorage.setItem('authToken', response.jwt);
      this.router.navigateByUrl('/dashboard');
    }
    else {
      this.model.password = '';
      this.showAlertBox(response.message, 3);
      this.accountLocked = (response.accountStatus == 203);
      window.scrollTo(0, 0);
    }
  }

}
